import { InferenceResultObsrec } from './InferenceResultObsrec';
import { InferenceAdditionalResultObsrec } from './InferenceAdditionalResultObsrec';

/**
 * 観察簿データ
 */
export class KansatsuKirokuObsrec {
  koujiBangou: string;
  key: string;
  kansatsuDate: string; // 観察年月日(YYYY-MM-DD)
  sokutenNumber: string; // 測点No
  danmenNumber: string; // 断面番号
  kyori: string; // 坑口からの距離
  kansatsuDateMemo: string; // 観察年月日(YYYY-MM-DD)
  sokutenNumberMemo: string; // 測点No
  danmenNumberMemo: string; // 断面番号
  kyoriMemo: string; // 坑口からの距離
  inferenceResultObsrecJsonStr: string; // 推論結果のJSONの文字列表現(利用しない)
  inferenceAdditionalResultObsrecJsonStr: string; // 推論結果追加情報のJSONの文字列表現(利用しない)
  inferenceResultObsrec: InferenceResultObsrec[];
  inferenceAdditionalResultObsrec: InferenceAdditionalResultObsrec;
  inferenceId: string;
  croppedImageBucket: string; // 切り抜き済み画像格納Bucket
  croppedImageKey: string; // 切り抜き済み画像格納key
  originalImageBucket: string; // オリジナル画像格納Bucket
  originalImageKey: string; // オリジナル画像格納key
  croppedImageSignedUrl: string;
  // 自由入力欄
  freeInputs: Array<{
    title: string;
    value: string;
    memo: string;
  }>
  freeInputsJsonStr: string;
  createdAt: string; // 作成日時
  lastModifiedAt: string; // 最終更新日時
  deletedAt: string; // 削除日時
  downloadFileStatus: string;
  downloadFileBucket: string;
  downloadFileKey: string;
  downloadFileCreationDatetime: string; // ダウンロードファイルの作成日時 YYYY-MM-DDThh:mm:ss+0900
  downloadFileUrl: string; // ダウンロードファイルのSignedURL
  
  // 人判断の手入力スコア関連
  matrixElementNum : { // 細分化の情報
    lineNum : string; // 行数
    columnNum : string; // 列数
  };
  // 観点と位置とスコア
  observationsScores: Array<{
    observation: string; // 観察項目
    scores: Array<{
      position: string; // 位置（左上から右方向でカウントしたときの位置）
      score: string; // スコア
    }>;
  }>;
  observationsScoresJsonStr: string;
}


// WEBPACK FOOTER //
// ./src/models/KansatsuKirokuObsrec.ts